import { render, staticRenderFns } from "./View18.vue?vue&type=template&id=98d54ca0&scoped=true&"
import script from "./View18.vue?vue&type=script&lang=js&"
export * from "./View18.vue?vue&type=script&lang=js&"
import style0 from "./View18.vue?vue&type=style&index=0&id=98d54ca0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d54ca0",
  null
  
)

export default component.exports